import { render, staticRenderFns } from "./MarkdownBlogs.vue?vue&type=template&id=98f5fe4e"
import script from "./MarkdownBlogs.vue?vue&type=script&lang=js"
export * from "./MarkdownBlogs.vue?vue&type=script&lang=js"
import style0 from "./MarkdownBlogs.vue?vue&type=style&index=0&id=98f5fe4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports